import styled from 'styled-components';

const SecondaryContainer = styled.div`
  height: 222px;
  overflow: hidden;
  position: relative;
  margin-bottom: 12px;

  .header_image {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    object-fit: ${({ withCustomPhoto }) =>
      withCustomPhoto ? ' cover' : 'contain'};
  }
`;

export default SecondaryContainer;
